import "./index.scss";

import React, { useEffect } from "react";
import gsap from "gsap";

const Success = ({ isOpen, type }) => {
  useEffect(() => {
    if (isOpen) {
      const tl = gsap;

      tl.to(".success", {
        zIndex: 13,
        opacity: 0,
      });

      tl.to(".countdown-form", 0.3, {
        delay: 0.2,
        opacity: 0,
      });
      tl.to(".success", 1, {
        delay: 0.1,
        opacity: 1,
      });

      tl.to("html", {
        overflowY: "hidden",
      });

      tl.to(".success__text--1st", 0.3, {
        delay: 1,
        transform: "translateY(0vh)",
        opacity: 1,
      });
      tl.to(".success__text--2nd", 0.3, {
        delay: 1.1,
        transform: "translateY(0vh)",
        opacity: 0.8,
      });
      tl.to(".success__text--3rd", 0.3, {
        delay: 1.2,
        transform: "translateY(0vh)",
        opacity: 0.6,
      });
      tl.to(".success__text--4th", 0.3, {
        delay: 1.3,
        transform: "translateY(0vh)",
        opacity: 0.4,
      });
      tl.to(".success__text--5th", 0.3, {
        delay: 1.4,
        transform: "translateY(0vh)",
        opacity: 0.2,
      });
      tl.to(".success__text--6th", 0.3, {
        delay: 1.5,
        transform: "translateY(0vh)",
        opacity: 0.2,
      });
    } else {
      const tl = gsap;
      tl.to(".countdown-form", {
        delay: 0.5,
        opacity: 1,
      });

      tl.to(".success", 0.5, {
        opacity: 0,
      });
      tl.to(".success", 0.1, {
        delay: 0.5,
        zIndex: -1,
      });

      tl.to(
        ".success__text--1st, .success__text--2nd, .success__text--3rd, .success__text--4th, .success__text--5th",
        {
          delay: 1,
          transform: "translateY(20vh)",
          opacity: 0,
        }
      );
    }
  }, [isOpen]);

  return (
    <div className={`success`}>
      {["proof", "match"].includes(type) ? (
        <>
          <p className={` success__text success__text--1st`}>Thank you!</p>
          <p className={`success__text success__text--2nd`}>
            We’ll let you know
          </p>
          <p className={`success__text success__text--3rd`}>
            when MA <span className={`success__text-type`}>{type}</span>
          </p>
          <p className={`success__text success__text--4th`}>goes live.</p>
        </>
      ) : type === "gallery" ? (
        <>
          <p className={`success__text success__text--1st`}>Thank you!</p>
          <p className={`success__text success__text--2nd`}>We’ll keep you</p>
          <p className={`success__text success__text--3rd`}>in the loop</p>
          <p className={`success__text success__text--4th`}>about MA Gallery</p>
          <p className={`success__text success__text--5th`}>updates.</p>
        </>
      ) : type === "contactus" ? (
        <>
          <p className={`success__text success__text--1st`}>Thank you!</p>
          <p className={`success__text success__text--2nd`}>We will be</p>
          <p className={`success__text success__text--3rd`}>
            in touch with you
          </p>
          <p className={`success__text success__text--4th`}>shortly.</p>
        </>
      ) : type === "appSupport" ||type === "appSupportArt" ? (
        <>
          <p className={`success__text success__text--1st`}>Thank you!</p>
          <p className={`success__text success__text--2nd`}>A member of</p>
          <p className={`success__text success__text--3rd`}>our support team</p>
          <p className={`success__text success__text--4th`}>will contact you</p>
          <p className={`success__text success__text--5th`}>shortly.</p>
        </>
      ) : type === "signIn" ? (
        <>
          <p className={`success__text success__text--1st`}>Thank you!</p>
          <p className={`success__text success__text--2nd`}>
            We will process your data
          </p>
          <p className={`success__text success__text--3rd`}>and let you know</p>
          <p className={`success__text success__text--4th`}>
            when the inventory
          </p>
          <p className={`success__text success__text--5th`}>
            is set up in your
          </p>
          <p className={`success__text success__text--6th`}>account.</p>
        </>
      ) : null}
    </div>
  );
};

export default Success;
